import {batch, computed, signal} from "@preact/signals-react";


export const productsMatcherItems = signal(null)
export const productsMatcherImageSize = signal(1)
export const isLoadMoreItems = signal(false)
export const productsMatcherImageComparatorModalData = signal({})
export const productsMatcherGroupBy = signal(null) // null | 'reference' | 'productURL'
export const productsMatcherBatchGroupBy = signal(null) // inherited from batch (read-only)
export const productsMatcherGroupedProductIDs = signal([]) // additional product IDs from the selected group

// Computed
export const isProductsMatcherLoading = computed(() => productsMatcherItems.value === null)
export const productsMatcherImageSizeValue = computed(() => [150, 200, 250][productsMatcherImageSize.value])

// Functions
export const clearProductsMatcherSignals = () => batch(() => {
	productsMatcherItems.value = null
	productsMatcherImageSize.value = 1
	isLoadMoreItems.value = false
	productsMatcherImageComparatorModalData.value = {}
	productsMatcherGroupBy.value = null
	productsMatcherBatchGroupBy.value = null
	productsMatcherGroupedProductIDs.value = []
})